// assets/dh-editor-topbar.js
// Wires the toolbar above the editor: color menu show/hide, color-change
// hand-off to the editor canvas, and the title/price text. Runs on
// /pages/editor; assumes dh-editor-insert.js has already configured the SDK.
(function () {
  const QS = () => new URLSearchParams(location.search);

  function parseProduct() {
    const raw = (QS().get("product") || "").toLowerCase().trim();
    if (!raw) return { base: null, suffixColor: null };
    const m = raw.match(/^(hat|hoodie)(?:-([a-z0-9-]+))?$/i);
    if (m) return { base: m[1].toLowerCase(), suffixColor: m[2] || null };
    return { base: raw, suffixColor: null };
  }

  function getHandle() {
    return (
      parseProduct().base ||
      document.querySelector("[data-editor-toolbar]")?.dataset.productHandle?.toLowerCase() ||
      "sticker"
    );
  }

  function getColor() {
    const qsColor = (QS().get("color") || "").toLowerCase().trim();
    if (qsColor) return qsColor;
    const { base, suffixColor } = parseProduct();
    if (DH.isApparelType(base) && suffixColor) return suffixColor.toLowerCase();
    return DH.isApparelType(base) ? "white" : "";
  }

  function waitForEditor(cb, tries = 80) {
    if (window.editor && typeof window.editor.changeProductImage === "function") return cb();
    if (tries <= 0) return;
    setTimeout(() => waitForEditor(cb, tries - 1), 125);
  }

  function setUrlColor(color) {
    const url = new URL(location.href);
    url.searchParams.set("color", color);
    history.replaceState(null, "", url.toString());
  }

  // Toggle visibility of the color menu + its label (apparel only).
  function toggleColorMenu(show) {
    const menu = document.querySelector(".dh-color-menu");
    if (!menu) return;
    const group = menu.closest(".editor-toolbar__group");
    const label = group?.querySelector(".editor-toolbar__label") || document.getElementById("color-label");
    menu.classList.toggle("hidden", !show);
    label?.classList.toggle("hidden", !show);
  }

  // Radio values are capitalized (White/Tan/Purple); color is lowercased
  // from the URL, so compare case-insensitively.
  function syncColorMenuSelection(color) {
    const menu = document.querySelector(".dh-color-menu");
    if (!menu) return;
    const want = (color || "").toLowerCase();
    const pick = [...menu.querySelectorAll('input[type="radio"]')]
      .find((r) => (r.value || "").toLowerCase() === want);
    if (pick && !pick.checked) pick.checked = true;
  }

  // When the user picks a new color, persist it to ?color= and re-paint
  // the apparel background in the editor canvas.
  function bindColorMenu(handle, hasHash) {
    const menu = document.querySelector(".dh-color-menu");
    if (!menu) return;
    menu.addEventListener("change", (e) => {
      const input = e.target.closest('input[type="radio"]');
      if (!input) return;
      const color = (input.value || "").toLowerCase();
      setUrlColor(color);
      if (DH.isApparelType(handle)) {
        const url = DH.resolveApparelBg(handle, color, hasHash);
        waitForEditor(() => window.editor.changeProductImage({ product_image_url: url }));
      }
    });
  }

  // Optional product title/price hydration (set by dh-product-customize.js
  // before navigating into the editor).
  function updateToolbarPriceTitle() {
    try {
      const pd = JSON.parse(localStorage.getItem("dh_product_data") || "null");
      if (!pd) return;
      const t = document.querySelector(".editor-toolbar__title");
      const p = document.querySelector(".editor-toolbar__price");
      if (t && pd.title) t.textContent = pd.title;
      if (p && typeof pd.price_cents === "number") p.textContent = `$${(pd.price_cents / 100).toFixed(2)}`;
    } catch (_) {}
  }

  function init() {
    const handle    = getHandle();
    const isApparel = DH.isApparelType(handle);
    const color     = getColor() || (isApparel ? "white" : "");
    const hasHash   = DH.hasUploadedLogo();

    toggleColorMenu(isApparel);
    if (isApparel) syncColorMenuSelection(color);
    bindColorMenu(handle, hasHash);
    updateToolbarPriceTitle();

    // On load, ensure the editor shows the correct apparel background.
    if (isApparel) {
      const url = DH.resolveApparelBg(handle, color, hasHash);
      waitForEditor(() => window.editor.changeProductImage({ product_image_url: url }));
      if (!QS().get("color")) setUrlColor(color);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
